import axios from 'axios';
import { Modal } from 'antd';
import { goLogin } from 'src/common/login';
import { isPlainObject } from 'lodash';
import eventEmitter from 'src/eventEmits';
import { MessageOpt } from 'src/eventEmits/message';
import { getFilenameFromResponse } from 'src/utils/blob';
import getIsExcludePathsResponseProcess from './excludePathsResponseProcess';

const Instance = axios.create({
  headers: {},
});

Instance.interceptors.request.use(
  (config: any) => {
    const { headers, ...rest } = config;
    return {
      ...rest,
      headers: {
        ...headers,
        Token: localStorage.getItem('token'),
        person: localStorage.getItem('ACCOUNT_TYPE') === 'person' ? 'true' : 'false',
      },
    };
  },
  (error) => Promise.reject(error),
);

Instance.interceptors.response.use(
  (response) => {
    if (isPlainObject(response.data)) {
      const {
        isSuccess, resultMsg, succeed, message,
      } = response.data;
      if (isSuccess === false && resultMsg === '用户已离职') {
        if (!localStorage.getItem('lizhiModal')) {
          localStorage.setItem('lizhiModal', '1');
          Modal.confirm({
            title: null,
            okText: '确认',
            centered: true,
            cancelButtonProps: { style: { display: 'none' } },
            content: (
              <div>
                <div>尊敬的客户：</div>
                <div>您的状态已被管理员变更为「离职」，请重新进行律师认证。</div>
              </div>
            ),
            onOk: () => {
              localStorage.removeItem('lizhiModal');
              window.location.href = `${window.location.origin}/#/admin/account-auth`;
            },
          });
        }
        return response.data;
      }
      if (isSuccess === false) {
        // MessageComponent.error(resultMsg || '接口好像失败了', 2);
        const msgOpt: MessageOpt = {
          type: 'error',
          options: {
            content: resultMsg,
          },
        };
        eventEmitter.emit('message', msgOpt);
      } else if (succeed === false) {
        // MessageComponent.error(message || '接口好像失败了', 2);
        const msgOpt: MessageOpt = {
          type: 'error',
          options: {
            content: message,
          },
        };
        eventEmitter.emit('message', msgOpt);
      }
    } else if (response.data instanceof Blob) {
      // 从响应头或 URL 中提取文件名
      const filename = getFilenameFromResponse(response) || 'downloaded-file';
      console.log(filename);
      return {
        filename,
        data: response.data,
      };
    }
    return response.data;
  },
  (error) => {
    const { response: { status } } = error;
    if (status === 401) {
      if (process.env.REACT_APP_SITE_NAME === 'industry-ccc') {
        localStorage.removeItem('token');
        const msgOpt: MessageOpt = {
          type: 'warning',
          options: {
            content: '请登录后重试',
          },
        };
        eventEmitter.emit('message', msgOpt);
      } else {
        localStorage.removeItem('token');
        if (process.env.REACT_APP_BASE_ENV !== 'local') {
          // 开发环境暂不跳转，避免对开发者造成困惑，后续优化
          goLogin();
        }
      }
    }
    return Promise.reject(error);
  },
);

export default Instance;
